import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

// Two diagonal arrows (↖ and ↘) for resize/drag indication
export const ArrowsTopLeftBottomRightIcon = React.memo(
  function ArrowsTopLeftBottomRightIcon({
    color = "currentColor",
    ...props
  }: IconProps) {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.5 6.5L2.5 2.5M2.5 2.5V6.5M2.5 2.5H6.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 8.5L12.5 12.5M12.5 12.5V8.5M12.5 12.5H8.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
